<template>
  <!-- 纵向的菜单,由于折叠时hover会报错，因此多加一层div，用样式解决 -->
  <!-- 有子节点，用el-submenu -->
  <div v-if="menuTreeItem.menu_type != 'function'">
    <el-submenu v-if="menuTreeItem.children && menuTreeItem.children.length >= 1 || menuTreeItem.haveChildren"
      :index="menuTreeItem.menu_id.toString()" :key="'submenu' + menuTreeItem.menu_id">
      <template slot="title">
        <!-- 图标 -->
        <i v-if="menuTreeItem.menu_icon && menuTreeItem.menu_icon.indexOf('el-icon-') > -1" :class="menuTreeItem.menu_icon"></i>
        <i v-else-if="menuTreeItem.menu_icon && menuTreeItem.menu_icon.indexOf('icon-') > -1" class="iconfont"
          :class="menuTreeItem.menu_icon"></i>
        <i v-else class="el-icon-star-off" style="font-size:12px;"></i>
        <!-- 文字 -->
        <i v-if="collapse" class="el-icon-arrow-right menu-has-child"></i>
        <span slot="title">{{ menuTreeItem.menu_name }}</span>
      </template>
      <el-badge v-if="getChildrenBadge(menuTreeItem.children) > 0" style="float:right;"
        :value="getChildrenBadge(menuTreeItem.children)">
      </el-badge>
      <el-menu-item-group>
        <menuTree v-for="item in menuTreeItem.children" :key="item.menu_id" :menuTreeItem="item" />
      </el-menu-item-group>
    </el-submenu>
    <!-- 没有子节点，直接el-menu-item -->
    <el-menu-item v-else :index="menuTreeItem.menu_link" :route="'/' + menuTreeItem.menu_link" :key="menuTreeItem.menu_link">
      <!-- 图标 -->
      <i v-if="menuTreeItem.menu_icon && menuTreeItem.menu_icon.indexOf('el-icon-') > -1" :class="menuTreeItem.menu_icon"></i>
      <i v-else-if="menuTreeItem.menu_icon && menuTreeItem.menu_icon.indexOf('icon-') > -1" class="iconfont"
        :class="menuTreeItem.menu_icon"></i>
      <i v-else class="el-icon-star-off" style="font-size:12px;"></i>
      <!-- 文字 -->
      <span slot="title">{{ menuTreeItem.menu_name }}</span>
      <el-badge v-if="getAllBadge(menuTreeItem.menu_link) > 0" style="float:right;" :value="getAllBadge(menuTreeItem.menu_link)">
      </el-badge>
    </el-menu-item>
  </div>
</template>

<script>
export default {
  name: "menuTree",
  props: {
    menuTreeItem: {
      type: [Object, Array],
      required: true
    },
    collapse: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    //获取角标
    getAllBadge(value) {
      var count = 0;
      if (value) {
        if (this.$store.state.badge[value] != undefined) {
          count = this.$store.state.badge[value];
        } else {
          //动态添加
          this.$store.state.badge[value] = 0;
        }
      }
      return count;
    },
    //获取子节点的角标
    getChildrenBadge(array) {
      var count = 0;
      for (var i = 0; i < array.length; i++) {
        if (array[i].children && array[i].children.length > 0) {
          //有子节点
          count += this.getChildrenBadge(array[i].children);
        } else {
          //没有子节点
          count += this.getAllBadge(array[i].menu_link);
        }
      }
      return count;
    }
  }
};
</script>

<style>
/* 纵向排列hover报错，在外层加个div */
.el-menu--collapse > div > .el-submenu > .el-submenu__title span {
  height: 20px;
  line-height: 20px;
  display: block;
  font-size: 13px;
}

.el-menu--collapse
  > div
  > .el-submenu
  > .el-submenu__title
  .el-submenu__icon-arrow {
  display: none;
}

/* 纵向菜单排列个性化显示文字 */
.el-menu > div > .el-submenu .iconfont {
  display: inline-block;
  margin-right: 5px;
  font-size: 18px;
  width: 24px;
  text-align: center;
}

.el-menu--collapse > div > .el-submenu [class^="el-icon-"],
.el-menu--collapse > div > .el-submenu .iconfont {
  margin-top: 5px;
  margin-right: 0 !important;
  display: block;
  font-size: 18px;
  width: 24px;
  text-align: center;
}

.el-menu--collapse > div > .el-submenu > .el-submenu__title {
  padding: 0 5px !important;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}

/* 只有一层的显示文字*/
.el-menu--collapse > .el-menu-item {
  margin: 0 !important;
  padding: 0 !important;
}

.el-menu--collapse > div > .el-menu-item {
  margin: 0 !important;
  padding: 0 !important;
}

.el-menu > div > .el-menu-item .iconfont {
  display: inline-block;
  margin-right: 5px;
  font-size: 18px;
  width: 24px;
  text-align: center;
}

.el-menu--collapse > div > .el-menu-item > .menuToolTip [class^="el-icon-"],
.el-menu--collapse > div > .el-menu-item > .menuToolTip .iconfont {
  margin-top: 5px;
  margin-right: 0 !important;
  display: block;
  font-size: 18px;
  width: 24px;
  text-align: center;
}

.el-menu--collapse > div > .el-menu-item > .menuToolTip {
  padding: 0 5px !important;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.el-menu--collapse > .el-menu-item > .menuToolTip {
  padding: 0 5px !important;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.el-menu--collapse > div > .el-menu-item > .menuToolTip span {
  height: 20px;
  line-height: 20px;
  display: block;
  font-size: 13px;
  visibility: unset;
  overflow: unset;
  width: unset;
}

.el-menu--collapse > .el-menu-item > .menuToolTip span {
  height: 20px;
  width: 100%;
  line-height: 20px;
  display: block;
  font-size: 13px;
  visibility: unset;
  overflow: unset;
  width: unset;
}

.menu-has-child {
  position: absolute;
  font-size: 12px !important;
  right: 0;
  top: 3px;
}
.menu-tooltip-x .popper__arrow {
  border-width: 0px !important;
}
.menu-tooltip-x .popper__arrow::after {
  border-width: 0px !important;
}
</style>